/**
 * 日付関連メソッド
 */
export default class DateUtils {
  /**
   * フォーマッタ
   *
   * @param date 日付
   * @param long 時間表示の有無
   * @returns フォーマットされた日付
   */
  public static format(date: Date, long: boolean = true): string {
    const year = date.getFullYear().toString()
    const month = (date.getMonth() + 1).toString().padStart(2, '0')
    const day = date.getDate().toString().padStart(2, '0')
    let time = ''
    if (long) {
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')
      time = ` ${hours}:${minutes}`
    }
    const separator = '/'
    return `${year}${separator}${month}${separator}${day}${time}`
  }

  /**
   * 開始日時〜終了日時の形式で返す
   *
   * @param start 開始日時
   * @param end 終了日時
   * @returns 表示用の形式になった日付
   */
  public static startToEnd(start: string, end: string): string {
    return `${start} 〜 ${end}`
  }

  /**
   * 現在時刻のタイムスタンプ取得
   *
   * @returns タイムスタンプ(yyyyMMddHHmmss)
   */
  public static getTimestamp(): string {
    const date = new Date()

    // 年、月、日、時、分、秒をそれぞれ取得
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    return `${year}${month}${day}${hours}${minutes}${seconds}`
  }
}
